(function ($) {
  $(function () {


      $('.right-nav__item_search').on('click',function(e) {
        e.preventDefault();
        $('.header__search').slideToggle();
        $('#search-form .header__search-input').focus();
      })
      $('.header__search-close').on('click',function() {
        $('.header__search ').slideUp();
      });
      $('.reset-pass').on('click',function(e) {
        e.preventDefault();
        $('.customer__login').addClass('show-reset');
      });
      $('.back-to-login').on('click',function(e) {
        e.preventDefault();
        $('.customer__login').removeClass('show-reset');
      });

// var my_country = $('.address-country').attr('data-default');
// $('.address-country').val(my_country);

      $('.customer__nav-url').click(function(e) {
        e.preventDefault();
        var my_tab = $(this).attr('data-target');
        $('.customer__nav-url').removeClass('active');
        $(this).addClass('active');
        $('.customer__tab-content').removeClass('active');
        $(my_tab).addClass('active');
      })


    if($('.product-item-content').length >0) {
      let h = 0;
      $('.product-item-content').each(function(){
        let this_h = $(this).outerHeight();
        if(this_h > h) {
          h = this_h;
        }
      });
      $('.product-item-content').css('height',h);

    }

    if ($(".suggestions-wrap").length > 0) {
      $(".suggestions-wrap p span").on("click", function () {
        let value = $(this).html();
        $(".header__search-input").val(value);
        $("#search-form").submit();
      });
    }

    if (!$(".header-top").length > 0) {
      $("body").addClass("header-fixed");
    }
    if ($(".menu-item-has-children").length > 0) {
      $(".menu-item-has-children").each(function () {
        $(this).on("mouseenter", function () {
          if ($(window).width() > 767) {
            if (!$(this).find(".children").is(":visible")) {
              $(this).find(".children").slideDown(100);
            }
          }
        });
        $(this).on("mouseleave", function () {
          if ($(window).width() > 767) {
            if ($(this).find(".children").is(":visible")) {
              $(this).find(".children").slideUp(100);
            }
          }
        });
      });
      if ($(window).width() < 768) {
        $(".menu-item-has-children > a").on("click", function (e) {
          e.preventDefault();
          if ($(this).parent().find(".children").is(":visible")) {
            $(this).parent().find(".children").slideUp();
          } else {
            $(this).parent().find(".children").slideDown();
          }
        });
      }
    }
  });
})(jQuery);

if($(".cart-upsell__items").length > 0) {
  $(".cart-upsell__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.cart-upsell__offer',
    prevArrow:
      "<div class='hero__slider-arrow hero__slider-arrow_left'><img src='https://cdn.shopify.com/s/files/1/2318/2001/files/arl.svg?v=1664546225'></div>",
    nextArrow:
      "<div class='hero__slider-arrow hero__slider-arrow_right'><img src='https://cdn.shopify.com/s/files/1/2318/2001/files/arr.svg?v=1664546225'></div>",
  });
  $('.cart-upsell__offer').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.cart-upsell__items'
  });
}


// ----------------- Get cart details -------------\\
function get_cart_details_new() {
  $.getJSON("/cart.js", function (cart) {
    // The cart data
    var drawer_item_html = "";
    var cart_items = cart.items;
    var total_items = cart.item_count;
    product_total_price = cart.total_price;

    $("body").addClass("cartShown");
    $(".cart").removeClass("cart-empty");
    $(".cart-total-amount").text(
      my_Shop_Currency +
        (product_total_price * 0.01)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );

    $(".add-to-cart-btn").removeClass("loading");
    $(".shopify-product-form").removeClass("loading");
    $(".sticky-cart-btn").removeClass("loading");
    $('.cool-btn').removeClass("loading");

    console.log(cart);
    for (var i = 0; i <= cart_items.length; i++) {
      var product_image = cart_items[i].image;
      var product_name = cart_items[i].product_title;
      var product_id = cart_items[i].id;
      var product_name_handlize = product_name.replace(/ /g, "-").toLowerCase();
      var product_variant_option_name =
        cart_items[i].options_with_values[0].name;
      var product_variant_option_value =
        cart_items[i].options_with_values[0].value;
      var product_variant = cart_items[i].variant_title;
      var product_quantity = cart_items[i].quantity;
      var product_price = cart_items[i].price;
      // var product_price_formatted = numberWithCommas(product_price);
      var product_variant_id = cart_items[i].variant_id;
      var product_url = cart_items[i].url;
      var product_key = cart_items[i].key;
      var da_product_total_price = cart_items[i].final_line_price;
      // var product_purchase_plan = cart_items[i].selling_plan_allocation.selling_plan.name;
      console.log(product_id);
      // console.log(product_purchase_plan);
      $("." + product_id).addClass("upsell__added");
      $(".your-cart-inner").removeClass("no-item");

      fetch("/?section_id=cart-drawer")
        .then((response) => response.text())
        .then((cartData) => {
          var cart_html = $(cartData);
          var cart_items = $(".product-cart-item-wrap", cart_html);
          var upsell_items = $(".cart-upsell", cart_html);
          console.log(cart_items);
          $(".product-cart-item-wrap").replaceWith(cart_items);
          $(".cart-upsell").replaceWith(upsell_items);
        });

      $(".product-cart-item-wrap").html(drawer_item_html);
      $(".cart-upsell__atc").removeClass("loading");
      setTimeout(function () {
        $(".product-single-hero-item").removeClass("loading");
      }, 1000);
    }
  });
}


$(document).on('click', '.sample-btn', function(){
  $('.free-sample').addClass('show-sample');
})


$('.free-sample__back').click(function(){
  $('.free-sample').removeClass('show-sample');
})


$(document).on('click', '.free-sample__button', function(){
  // e.preventDefault()
  $(this).addClass('loading');
  $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $(this).parent().find('.sample_product_form').serialize(),
        success: function(data) {

          get_cart_details();
        },
        error: 'addToCartFail'
    });
})

$('.cool-btn').click(function(){
  $(this).addClass('loading');
   var the_title = $(this).attr('data-title');
    $('.atc-confirmation__title').text(the_title);
  
  var added_product = $(this).attr('data-product');
    fetch('/products/'+added_product+'?section_id=product-recommendations')
    .then(response => response.text())
.then(cartData => {
    var cart_html = $(cartData);
    var cart_count = $('.recommended-products', cart_html);

    var customUpsellTitle =
        $('.recommendation-heading-data', cart_html).attr('data-heading') || '';

    var defaultUpsellTitle =
        $('.atc-confirmation .con-upsell__title').attr('data-default-title') || '';

    $('.atc-confirmation .con-upsell__title').text(
        customUpsellTitle.trim() || defaultUpsellTitle
    );

    $('.atc-confirmation .recommended-products').replaceWith(cart_count);
});
  $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: $(this).parent().serialize(),
        success: function(data) {
          open_atc_confirmation();
          get_cart_details();
        },
        error: 'addToCartFail'
    });
});

$('.blogs .blogs__items').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  arrows: false,
  dots: false,
  adaptadaptiveHeight: true,
  responsive: [
      {
          breakpoint: 768,
          settings: 'unslick'
      }
  ]
});


$('.sub-feequency__selected').click(function(e){
  e.stopPropagation();
  $(this).next().slideToggle();
})

// $(document).click(function() {
//   $('.sub-feequency__items').slideUp();
// });


$('.sub-feequency__item').click(function(){
  var plan_selected = $(this).attr('plan-id');
  var plan_selected_text = $(this).text();
  $('.sub-feequency__selected span').text(plan_selected_text);
  $('.selling-plan-inp').val(plan_selected);
  $('.sub-feequency__items').slideUp();
})


$('.t-category__nav_js').click(function(e){
  e.preventDefault();
  var category = $(this).attr('data-target');
  $('.t-category__panel').css('display', 'none');
  $(category).css('position', 'relative');
  $(category).css('opacity', '100');
  $(category).fadeIn();
  $('.t-category__panel').removeClass('active');
  $(category).addClass('active');

  $('.t-category__nav_js').removeClass('active');
  $(this).addClass('active');
});


$('.tutorial__item').click(function(){
  var video = $(this).attr('data-video');
  var video_desc = $(this).attr('data-desc');
  $('.tutorial__video iframe').attr('src', video);
  $('.tutorial__modal').addClass('show-video');
  $('.tutorial__video-description').html(video_desc);
});


$('.tutorial__modal').click(function(){
  $('.tutorial__modal').removeClass('show-video');
  $('.tutorial__video iframe').attr('src', '');
});


$('.look__image-inner').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: true,
});

// $('.look__items').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   dots: true,
//   infinite: true,
//   adaptiveHeight: true,
// });

// $('.look__items_centered').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   dots: true,
//   // infinite: false,
//   centerMode: true,
//   // centerPadding: '165px',
//   // variableWidth: true,
//   initialSlide: 1,
//   // adaptiveHeight: true,
// });


if($('.slider-arrows__left').length > 0 ){
  $('.slider-arrows__left').on('click',function(){
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
  });
}
if($('.slider-arrows__right').length > 0 ){
  $('.slider-arrows__right').on('click',function(){
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
  });
};

if($('.look-arrow__left').length > 0 ){
  $('.look-arrow__left').on('click',function(){
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
  });
}
if($('.look-arrow__right').length > 0 ){
  $('.look-arrow__right').on('click',function(){
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
  });
};


// if($('.look__product').length >0) {
//   let h = 0;
//   $('.look__product').each(function(){
//     $(this).find('.product-item-content').each(function(){
//       let this_h = $(this).outerHeight();
//       if(this_h > h) {
//         h = this_h;
//       }
//     });
//     $(this).find('.product-item-content').css('height',h);
    
//   });
  

// }






// $('.t-category__nav_blog').click(function(e){
//   e.preventDefault();
//   var blog_url = $(this).attr('href');

//   fetch(blog_url+"/?section_id=tutorial-blog")
//     .then((response) => response.text())
//     .then((blogData) => {
//       var blog_html = $(blogData);
//       var articles = $(".articles", blog_html);
//       $(".articles").replaceWith(articles);
//     });
// });